import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nimbus-material-tabs-wrapper',
  templateUrl: 'material-tabs-wrapper.component.html',
  styleUrls: ['./material-tabs-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'nimbus-tab-wrapper',
  },
})
export class MaterialTabsWrapperComponent {}
